__turbopack_context__.v({
  "className": "roboto_70f48f58-module__Fz8QOG__className",
});
